<template>
  <div class="IntroductionPage">
    <div class="bg-white p-4" id="intro">
      <h3 class="mb-3">Slim &amp; Snel - Wijkprofielen</h3>
      <p>
        Het is de verantwoordelijkheid van gemeenten om uiteindelijk alle inwoners mee te krijgen in de energietransitie. Deze tool is ontstaan vanuit de behoefte aan slimme oplossingen om snel tot inzicht en voortgang te komen.
        
        <!-- Dit gaat gepaard met diverse uitdagingen, waaronder de versnippering van het streetbeeld. 
        Een bekende term is wellicht 'gespikkeld bezit'. Hierbij zijn naastgelegen panden in bezit van diverse typen eigenaren (e.g. woningbouwcooperaties en private eigenaren). Een andere uitdaging is participatie. Er zijn enthousiaste voorlopers, maar ook "kat uit de boom kijkers".  -->
      </p>

      <p>
        Door op pand niveau woningen in te delen op basis van <strong class="text-secondary">4 eigenschappen</strong> ontstaat een duidelijk, visueel beeld van de mate waarin buurten versnipperd zijn. Deze clustering noemen we <strong class="text-secondary">barcodes</strong>. 
        Aanvullend is er op straatniveau gekeken naar de gevels van naburige panden. Op basis hiervan zijn de panden in de buurten ingedeelt in <strong class="text-secondary">bouwblokken</strong>. Tot slot is er per buurt enige socio-economische informatie beschikbaar.
      </p>
    </div>
    <div class="bg-white p-4 mt-3" id="barcodes">
      <h3 class="mb-3">Uitleg over Barcodes</h3>
      <p>
        Deze applicatie baseert op het stapelen van vier informatielagen: het type eigenaar, het energielabel, de WOZ-waarde en de bouwperiode van woningen.
      </p>
      <p>
        Voor elke informatielaag zijn meerdere categorieën beschikbaar. De bouwperiode kent bijvoorbeeld zes categorieën: ‘Voor 1946’, ‘1946-1964’, ‘1965-1974’, ‘1975-1991’, ‘1992-2005’ en ‘na 2006’.
      </p>
      <p>
        Elke categorie van elke informatielaag heeft een eigen codeletter of –cijfer.
      </p>
      <b-table-lite :items="items" :fields="fields"></b-table-lite>
      <p>
        De combinatie van codes uit de vier informatielagen noemen wij een barcode: een uniek identificatiemiddel om een specifiek type woning mee aan te duiden.
      </p>
      <p>
        Bijvoorbeeld: de barcode 1A66 verwijst naar woningen met een eigenaar-bewoner (1), energielabel A (A), een WOZ-waarde van €300.000 of meer (6) en een bouwjaar van na 2006 (6).
      </p>
      <p>
        Barcodes maken het mogelijk om snel te zien welke informatielagen zijn geactiveerd en om in termen van specifieke combinaties te kunnen praten.
      </p>
      
    </div>
    <div class="bg-white p-4 mt-3 mb-3" id="uitleg">
      <h3 class="mb-3">Uitleg over de applicatie</h3>
      <p>
        <strong>Barcode:</strong> deze weergave laat zien waar in de buurt de vijf meest voorkomende woningtypen (barcodes) zich bevinden die zijn die door u zijn ingeschakeld. De overige woningtypen worden gezamenlijk als ‘Overige’ aangegeven
      </p>
      <p>
        <strong>Bouwperiode:</strong> deze weergave toont uit welke bouwperiode de geselecteerde woningtypen (barcodes) stammen en waar zij zich in de buurt bevinden
      </p>
      <p>
        <strong>Eigendom:</strong> deze weergave geeft u voor elk geselecteerd eigenaarstype de locatie van de woningen die aan de selectie voldoen (barcodes)
      </p>
      <p>
        <strong>Energielabel:</strong> deze weergave laat zien waar in de buurt de geselecteerde woningen (barcodes) zich bevinden en welk energielabel zij hebben
      </p>
      <p>
        <strong>WOZ-waarde:</strong> deze weergave toont u waar in de buurt de geselecteerde woningen (barcodes) zich bevinden en welke WOZ-waarde zij hebben
      </p>
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'

export default {
  name: 'Introduction',
  data() {
    return {
      fields: [
        { label: 'Eigendom', key: 'eigendom', variant: 'dark-blue', class: 'text-center' },
        { label: 'Energielabel', key: 'energielabel', variant: 'red', class: 'text-center'  },
        { label: 'WOZ Waarde Klasse', key: 'wozwaardeklasse', variant: 'light-green', class: 'text-center'  },
        { label: 'Bouwperiode Klasse', key: 'bouwjaarklasse', variant: 'green', class: 'text-center'  }
      ]
    }
  },
  computed: {
    ...mapGetters('filters', [
      'getAllFilterInfo'
    ]),
    items() {
      let items = []
      let allFilters = this.getAllFilterInfo

      let length = Math.max(
        allFilters.eigendom.items.length, 
        allFilters.energielabel.items.length,
        allFilters.wozwaardeklasse.items.length, 
        allFilters.bouwjaarklasse.items.length
      )

      Array.from(Array(length)).forEach((_, index) => {
        items.push({
          eigendom: allFilters.eigendom.items[index] ? allFilters.eigendom.items[index].label : '',
          energielabel: allFilters.energielabel.items[index] ? allFilters.energielabel.items[index].label : '',
          wozwaardeklasse: allFilters.wozwaardeklasse.items[index] ? allFilters.wozwaardeklasse.items[index].label : '',
          bouwjaarklasse: allFilters.bouwjaarklasse.items[index] ? allFilters.bouwjaarklasse.items[index].label : ''
        })
      })
      return items
    }
  }
}
</script>

<style lang="scss">
.IntroductionPage {

  > div {
    max-width: calc(700px + 3rem);
  }
  p {
    font-size: 1.1rem;
    line-height: 1.9;
    max-width: 700px;
    margin-bottom: 1.2rem;
  }

  .table {
    max-width: 700px;
  }
}
</style>